import { Button } from '@chakra-ui/react';
import { UPGRADE_REDIRECT_BIZ_LINK, UPGRADE_REDIRECT_LINK } from 'constants/links';
import { UPGRADE } from 'constants/mixpanel';
import { Mixpanel } from 'libs/third-party/Mixpanel/mixpanel';
import { getUserPlanProperty } from 'libs/third-party/Mixpanel/mixpanel.helper';
import { UserType, UserTypes } from 'modules/User';
import { ReactElement, memo } from 'react';
import { useTranslation } from 'react-i18next';
import { setAnalyticsUpgradeFeatureProp } from 'utils/sessionStorage';

// User types that should not see the upgrade button
const CANNOT_UPGRADE_USER_TYPES: UserType[] = [UserTypes.Business, UserTypes.Enterprise, UserTypes.Education];

const UPGRADE_REDIRECT_LINKS_BY_TYPE: { [key: string]: string } = {
  [UserTypes.Free]: UPGRADE_REDIRECT_LINK,
  [UserTypes.Premium]: UPGRADE_REDIRECT_BIZ_LINK,
};

interface UpgradeButtonProps {
  userType?: UserType;
}

export const UpgradeButton = memo(({ userType }: UpgradeButtonProps): ReactElement | null => {
  const { t } = useTranslation('common_navbar');

  if (!userType || CANNOT_UPGRADE_USER_TYPES.includes(userType)) {
    return null;
  }

  // Redirect to subscription page
  const onClick = () => {
    Mixpanel.track(UPGRADE.eventName, {
      Feature: UPGRADE.feature.HeaderButtonEditor,
      'User Plan': getUserPlanProperty(userType),
    });

    setAnalyticsUpgradeFeatureProp(UPGRADE.feature.HeaderButtonEditor);
    window.open(UPGRADE_REDIRECT_LINKS_BY_TYPE[userType] || UPGRADE_REDIRECT_LINK, '_self');
  };

  const testId = 'navbar-upgrade-button';
  const label = 'Upgrade';

  return (
    <Button variant='upgrade' size='sm' data-testid={testId} aria-label={label} onClick={onClick}>
      {t('navbar.upgrade-button')}
    </Button>
  );
});

UpgradeButton.displayName = 'UpgradeButton';
